import { render } from "./Cobrowse.vue?vue&type=template&id=6b6579d7&lang=pug"
import script from "./Cobrowse.vue?vue&type=script&lang=js"
export * from "./Cobrowse.vue?vue&type=script&lang=js"

import "./Cobrowse.vue?vue&type=style&index=0&id=6b6579d7&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__